import { render } from "./IconStar.vue?vue&type=template&id=79a7de5e"
const script = {}

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__